import * as T from './types'

export default {
    [T.SET_STAR_DATA](state, payload) {
        state.starMapDetail = payload
    },
    [T.SET_MIP_API_LIST](state, payload) {
        state.mipApiList = payload
    },
}
